import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useRouteMatch } from 'react-router'
import { Order as OrderModel, IOrder, useAccountOrders } from 'msp-integrations'
import { Spinner, AlertBox } from 'msp-components'
import OrderActions from './OrderActions/OrderActions'
import OrderStatuses from './OrderStatuses/OrderStatuses'
import OrderDetailHeader from './OrderDetailHeader/OrderDetailHeader'
import OrderShipmentDetails from './OrderShipmentDetails/OrderShipmentDetails'
import OrderProductItemsList from './OrderProductItemsList/OrderProductItemsList'
import OrderTransactionSummary from './OrderTransactionSummary/OrderTransactionSummary'
import * as S from './AccountOrderDetail.styles'

const AccountOrderDetail = () => {
  const { params } = useRouteMatch<{ orderNo: string }>()
  const { ordersById, isLoading, fetchOrder } = useAccountOrders()
  const order = new OrderModel(ordersById[params.orderNo] || ({} as IOrder))
  const successBoxRef = useRef<AlertBox>()
  const [isCancelled, setIsCancelled] = useState(false)
  const [isError, setIsError] = useState(false)
  const [alertBoxMessage, setAlertBoxMessage] = useState({
    type: 'standard',
    message: ''
  })

  useEffect(() => {
    fetchOrder(params.orderNo)
  }, [params.orderNo])

  useEffect(() => {
    if (isCancelled) {
      setAlertBoxMessage(alertBoxMessage)
      successBoxRef.current?.showAlert()

      if (isError) {
        setTimeout(() => {
          setIsCancelled(false)
          setIsError(false)
        }, 2500)
      }
    }
  }, [isCancelled])

  return (
    <div className={S.Wrapper}>
      {isLoading && <Spinner />}
      {!isLoading && (
        <>
          <OrderDetailHeader order={order} />
          <OrderStatuses order={order} />
          <OrderShipmentDetails order={order} />
          <OrderProductItemsList order={order} />
          <OrderTransactionSummary order={order} />
          <OrderActions
            order={order}
            setIsCancelled={setIsCancelled}
            setAlertBoxMessage={setAlertBoxMessage}
            setIsError={setIsError}
          />
        </>
      )}
      {isCancelled && typeof document !== 'undefined' ? (
        ReactDOM.createPortal(
          <AlertBox
            ref={successBoxRef}
            type={alertBoxMessage.type}
            title={alertBoxMessage.message}
            autoCloseTime={2500}
          />,
          document!.body
        )
      ) : (
        <></>
      )}
    </div>
  )
}

AccountOrderDetail.getTemplateName = () => 'account-order-history'

export default AccountOrderDetail
